import { Component, OnInit, Inject } from '@angular/core';
import { NoteService } from 'src/app/services/note.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators, FormGroupDirective, NgForm, FormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { TrackService } from 'src/app/services/track.service';

@Component({
  selector: 'app-track-documentation',
  templateUrl: './track-documentation.component.html',
  styleUrls: ['./track-documentation.component.css']
})
export class TrackDocumentationComponent implements OnInit {

  track = this.data.track;
  sessionId: number = this.data.sessionId;
  matcher = new MyErrorStateMatcher();
  documentation = new FormControl('');
  formGroup = new FormGroup({ documentation: this.documentation});

  constructor(
                private trackService: TrackService,
                private  dialogRef: MatDialogRef<TrackDocumentationComponent>,
                @Inject(MAT_DIALOG_DATA) public data: TrackDocumentationComponent) { }

  ngOnInit(): void {
    let url = this.track.documentation;
    this.formGroup.get('documentation').setValue(url);
  }

  onSubmit(){
    this.matcher.submited = true;
    if (this.formGroup.invalid) {
      return;
    }
    if (this.track){
      this.transformToTrack();
      this.updateTrack();
    }
  }

  onClose() {
    this.dialogRef.close(this.track);
  }

  transformToTrack(){
    this.track.documentation = this.formGroup.get('documentation').value;
    this.track.sessionId = this.sessionId;
  }

  updateTrack(){
    this.trackService.updateTrack(this.track.id, this.track)
    .subscribe(
      (_) => {
        this.onClose();
      },
      error => {
        console.error(error);
      }
    );
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  submited = false;
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = this.submited;
    return !!(control && control.invalid && (isSubmitted));
  }
}
